import React from 'react';

const LacajaTheme = {
  headerLogo: {
    src: '/themes/theme/lacaja/la_caja_pink_small.png',
    alt: 'La caja influencers',
  },
  darkLogo: {
    src: '/themes/theme/lacaja/la_caja_pink_small.png',
    alt: 'La caja influencers',
    size: 100,
  },
  headerStyle: {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #ff0093',
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'LA CAJA PINK | CAMPAIGNS',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="70" src="/themes/theme/lacaja/la_caja_pink_small.png" alt="Lacaja Influencers" />
      <br />
    </div>
  ),
  shareSite: 'https://lacajar.dyzio.co',
};

export default LacajaTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/lacaja.js
 **/